// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .article-comment-toggle-label {
  margin-right: 8px;
}
/*# sourceMappingURL=ArticleCommentToggle.css.map */`, "",{"version":3,"sources":["webpack://./ArticleCommentToggle.less","webpack://./src/components/SizingGroup/ArticleCommentToggle/ArticleCommentToggle.less"],"names":[],"mappings":"AAAA;EAEE,iBAAA;ACAF;AACA,mDAAmD","sourcesContent":[".presize-root { \n .article-comment-toggle-label {\n  margin-right: 8px;\n} \n}",".presize-root .article-comment-toggle-label {\n  margin-right: 8px;\n}\n/*# sourceMappingURL=ArticleCommentToggle.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
